import { lazy } from 'react';

const Product = lazy(()=>import('./Product/Chatbox'));

const SttConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: 'stt',
      element: <Product />,
    },
  ],
}

export default SttConfig;